export default __webpack_public_path__ + "static/media/balao.92a78828.svg";